// extracted by mini-css-extract-plugin
module.exports = {"merchantAvatarFallback":"style_merchantAvatarFallback__c1fWo"};